<style scoped lang="scss">
  @import "../user";
  .order{
    border: 1px solid #E4E6EA;
    margin-top: 20px;
    .top{
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      padding:15px;
      dl{
        display: flex;
        dd{
          margin-right: 40px;
        }
      }
      .status{
        color: #014492;
        font-weight: bold;
      }
    }
    .products{
      li{
        display: flex;
        align-items: center;
        padding:20px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border-bottom: 0;
        }
        .img-box{
          width:106px;
          height:106px;
          margin-right: 20px;
          img{
            width: 100%;
            height:100%;
          }
        }
        .info{
          flex:1;
        }
        .title{
          font-size: 16px;
        }
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          width:33.33%;
          margin-top:8px;
          label{
            color:#999;
          }
        }
      }
    }
  }
  .products-lists{
    display: flex;
    .products{
      flex:1;
      border-right:1px solid #E4E6EA;
    }
    .status{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding:0 10px;
      text-align: center;
      dl{
        label{
          color:#999;
        }
        dd{
          display: block;
          margin:10px 0;
        }
      }
    }
  }
  @media screen and (max-width: 640px){
    h3.title{
      font-size: 20px!important;
    }
    .text-primary{
      line-height: 25px;
    }
    .user>>> .el-radio-group{
      margin-top: 10px;
    }
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">积分兑换记录</h3>
      <div class="search-form">
        订单状态：
        <el-radio-group v-model="status" @change="getOrders(status)">
          <el-radio label="">全部</el-radio>
          <el-radio label="NEED_SEND">进行中</el-radio>
          <el-radio label="FINISHED">已完成</el-radio>
        </el-radio-group>
      </div>
      <div class="order" v-for="item in orderLists" :key="item.id">
        <div class="top">
          <dl class="info">
            <dd>配送地址：{{sendAddress}}</dd>
            <dd>订单编号：<span class="text-primary">{{item.code}}</span></dd>
          </dl>
          <span class="text-primary">{{item.statusName}}</span>
        </div>
        <div class="products-lists">
          <ul class="products">
            <li>
              <div class="img-box">
                <img :src="item.goodsImgUrl">
              </div>
              <div class="info">
                <div class="title">{{item.goodsName}}</div>
                <dl>
                  <dd v-if="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
                  <dd><label>订单状态：</label>{{item.statusName}}</dd>
                  <dd><label>下单时间：</label>{{item.createTime | rTime}}</dd>
                  <dd><label>消耗积分：</label>{{item.point}}</dd>
                  <dd><label>配送员：</label>{{item.seller.realName}}</dd>
                </dl>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="no-data" v-show="orderLists.length === 0">暂无相关订单</div>
      <div class="page tr" v-show="total > 0">
        <el-pagination
          layout="sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { pointsOrders } from '@/services/api.index'
export default {
  data() {
    return {
      searchForm: {
        user: '',
        region: '',
        date: ''
      },
      orderLists: [],
      status: '',
      total: 0,
      sendAddress: '',
      isHeadMan: this.baseMethods.isHeadMan()
    }
  },
  created() {
    this.getOrders()
  },
  methods: {
    getOrders (status) {
      pointsOrders(status).then(res => {
        res.data.map(item => {
          switch (item.status) {
            case 'NEED_SEND':
              item.statusName = '待配送'
              break
            case 'FINISHED':
              item.statusName = '已完成'
              break
            case 'CANCEL':
              item.statusName = '订单取消'
              break
          }
        })
        const address = this.baseMethods.getLocalObj('memberInfo').deliveryAddress
        this.sendAddress = `${address.province}${address.city}${address.detail}`
        this.orderLists = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/integral_exchange.vue